import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationRoutingModule } from './registration.routing';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule, MatExpansionPanel, MatExpansionPanelHeader } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { SignupComponent } from './common-singup/signup/signup.component';
import { CorporateInfoComponent } from './components/corporate-info/corporate-info.component';
import { BusinessOwnerInfoComponent } from './components/business-owner-info/business-owner-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { RegistrationThankyouComponent } from './components/registration-thankyou/registration-thankyou.component';
import { RegistartionIntermediaryComponent } from './components/registartion-intermediary/registartion-intermediary.component';
import { SaudiabusinessLandingComponent } from './components/saudiabusiness-landing/saudiabusiness-landing.component';
import { ImageLinkListComponent } from './components/image-link-list/image-link-list.component';
import { FaqsComponent } from 'src/app/shared/components/faqs/faqs.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AdminInfoComponent } from './components/admin-info/admin-info.component';
import { AdminSignupComponent } from './common-singup/admin-signup/admin-signup.component';
import { LinkAccountDialogComponent } from './components/link-account-dialog/link-account-dialog.component';
import { StopOnboardingComponent } from '../../shared/components/stop-onboarding/stop-onboarding.component';
import { CAMModule } from '../cam/cam.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SignUpContentServiceService } from './services/sign-up-content-service.service';
import { GenerateTokenComponent } from './components/generate-token/generate-token.component';
import { DependentOnboardComponent } from './common-singup/dependent-onboard/dependent-onboard.component';
import { DependentTokenComponent } from './common-singup/dependent-token/dependent-token.component';


@NgModule({
    imports: [
        CommonModule,
        NgSelectModule,
        ReactiveFormsModule,
        RegistrationRoutingModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        HttpClientModule,
        MatDialogModule,
        MatNativeDateModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatRadioModule,
        MatSlideToggleModule,
        FormsModule,
        CAMModule,
        SharedModule,
        MatIconModule,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        SignupComponent,
        CorporateInfoComponent,
        BusinessOwnerInfoComponent,
        EmailVerificationComponent,
        RegistrationThankyouComponent,
        RegistartionIntermediaryComponent,
        SaudiabusinessLandingComponent,
        ImageLinkListComponent,
        FaqsComponent,
        AdminInfoComponent,
        AdminSignupComponent,
        LinkAccountDialogComponent,
        StopOnboardingComponent,
        GenerateTokenComponent,
        DependentOnboardComponent,
        DependentTokenComponent,
    ]
})
export class RegistrationModule { 

}
